// CSS
import "normalize.css/normalize.css";
import './styles/styles.scss'; // my styles

// JavaScript
import "./js/index.js";
